import { Autocomplete, MenuItem, Select, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import { getDataInput } from "../NewsLetter/DataInputAPI";
import { Box, Chip } from "@mui/material";
import ReactQuillData from "./ReactQuillData";
import ReactQuillData2 from "./ReactQuillData2";
import RichEditor from "./RichTextEditor";
import UploadFileForm from "./UploadFileForm";
import { useDataLayerValue } from "../../DataLayer/DataLayer";
import PropTypes from "prop-types";
import { getAllLocations } from "../../utils/ApiCalls/Locations";
import CountryLocation from "../../constants/CountryLocation";
import { DatePicker, message } from "antd";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import enUS from "antd/es/locale/en_US";
import zhCN from "antd/es/locale/zh_CN";
import zhTW from "antd/es/locale/zh_TW";
import {
  keyworkTranslation,
  locationLabels,
  sideLabels,
} from "../../constants/constant.config";

dayjs.extend(utc);
dayjs.extend(timezone);
const SINGAPORE_TZ = "Asia/Singapore";
// Forces every bare dayjs() call (including ones inside antd's own
// calendar/panel internals) to resolve in Singapore time instead of the
// editor's machine timezone — otherwise the same click on the RangePicker
// can resolve to a different calendar date depending on the editor's region.
dayjs.tz.setDefault(SINGAPORE_TZ);
// Anchors a picked calendar date to Singapore time, regardless of the
// editor's own browser timezone, so the stored date never drifts by a day.
const toSingaporeDate = (d) => dayjs.tz(dayjs(d).format("YYYY-MM-DD"), SINGAPORE_TZ);

const DyanmicFrom = ({
  attributes,
  data,
  extralabel,
  rootData,
  queryData,
  setData,
  level,
  active,
  error = [],
}) => {
  const { RangePicker } = DatePicker;
  let [root, setRoot] = useState();
  const [menuValues, setMenuValues] = useState({});
  const [mutliSelectShip, setMutliSelectShip] = useState([]);
  const [countryLocation, setCountryLocation] = useState([]);
  const [locationOption, setLocationOption] = useState([]);
  let [{ ships }] = useDataLayerValue();

  useEffect(() => {
    getOptionLocation();
  }, []);

  function getValueByPath(obj, path) {
    return path.split(".").reduce((acc, key) => {
      return acc && acc[key] !== undefined ? acc[key] : undefined;
    }, obj);
  }

  const getOptionLocation = async () => {
    let data = await getAllLocations();

    if (data.error) {
    } else {
      setLocationOption(data?.data || []);
    }
  };
  useEffect(() => {
    setRoot(rootData);
    // getMenus();
  }, [rootData]);
  useEffect(() => {
    getMenus();
  }, []);
  useEffect(() => {
    const shipField = attributes?.find((attr) => attr.type === "ship");
    const countryField = attributes?.find((attr) => attr.type === "country");
    let value;
    if (shipField) {
      value = data[shipField.key];
      setMutliSelectShip(normalizeArray(value));
    }
    if (countryField && locationOption.length > 0) {
      let savedNames = data[countryField.key];
      if (!Array.isArray(savedNames)) {
        savedNames = savedNames ? [savedNames] : [];
      }
      // Convert saved names to IDs
      const ids = savedNames.map(
        (name) => locationOption.find((loc) => loc.location_name === name)?.id
      );
      setCountryLocation(ids);
    }
  }, [data, attributes, locationOption]);
  const normalizeArray = (value) => {
    return Array.isArray(value) ? value : value ? [value] : [];
  };
  const getMenus = async () => {
    const data = {};

    // Use for...of for better handling of async/await
    for (const item of attributes) {
      if (item.type === "asyncselect") {
        data[item.key] = await getData(
          item?.slug,
          item?.label,
          item?.value,
          item.type,
          item.query,
          item?.simplified_chinese,
          item?.traditional_chinese
        );
      }
    }

    setMenuValues(data);
  };

  //  OLD CODE +++++++++++++++++++++++++++++++++++++++++++++++++++++++
  //  OLD CODE +++++++++++++++++++++++++++++++++++++++++++++++++++++++

  // const getData = async (
  //   slug,
  //   label,
  //   value,
  //   type,
  //   query,
  //   simplified_chinese,
  //   traditional_chinese
  // ) => {
  //   let dataquery = { page: 1, limit: 1000, ...queryData };
  //   if (queryData && query) {
  //     query.map((item) => {
  //       dataquery[item.key] = queryData[item.dataKey];
  //     });
  //   }
  //   let data = await getDataInput(slug, dataquery || {});

  //   return (
  //     data?.data?.map((item) => ({
  //       ...data,
  //       label:
  //         label.split(",").length > 0
  //           ? label
  //               .split(",")
  //               .map((val) => getValueByPath(item, val))
  //               .filter((item) => item !== null && item !== undefined)
  //               .join(", ")
  //           : item?.[label],
  //       simplified_chinese: simplified_chinese
  //         ? simplified_chinese.split(",").length > 0
  //           ? simplified_chinese
  //               .split(",")
  //               .map((val) => getValueByPath(item, val))
  //               .filter((item) => item !== null && item !== undefined)
  //               .join(", ")
  //           : item?.[simplified_chinese]
  //         : undefined,
  //       traditional_chinese: traditional_chinese
  //         ? traditional_chinese.split(",").length > 0
  //           ? traditional_chinese
  //               .split(",")
  //               .map((val) => getValueByPath(item, val))
  //               .filter((item) => item !== null && item !== undefined)
  //               .join(", ")
  //           : item?.[traditional_chinese]
  //         : undefined,
  //       value: item?.[value],
  //       extra: item,
  //     })) || []
  //   );
  // };

  const getMenu = (item) => {
    if (item?.menuOption && root) {
      let res = item.menuOption(root);
      return res.map((item, index) => (
        <MenuItem key={index + ""} value={item?.id}>
          {item.name}
        </MenuItem>
      ));
    } else if (item.option) {
      return item.option.map((item, index) => (
        <MenuItem key={index + ""} value={item?.id}>
          {item.name}
        </MenuItem>
      ));
    }
  };

  const getData = async (
    slug,
    label,
    value,
    type,
    query,
    simplified_chinese,
    traditional_chinese
  ) => {
    let dataquery = { page: 1, limit: 1000, ...queryData };
    if (queryData && query) {
      query.forEach((item) => {
        dataquery[item.key] = queryData[item.dataKey];
      });
    }

    let response = await getDataInput(slug, dataquery || {});
    const list = response?.data?.venueMasterList || [];

    return list.map((item) => ({
      ...item,
      label: label?.includes(",")
        ? label
            .split(",")
            .map((val) => getValueByPath(item, val))
            .filter((v) => v !== null && v !== undefined)
            .join(", ")
        : item?.[label] || item?.name || "",
      simplified_chinese: simplified_chinese?.includes(",")
        ? simplified_chinese
            .split(",")
            .map((val) => getValueByPath(item, val))
            .filter((v) => v !== null && v !== undefined)
            .join(" | ")
        : item?.[simplified_chinese] || item?.name_simplified_chinese || "",
      traditional_chinese: traditional_chinese?.includes(",")
        ? traditional_chinese
            .split(",")
            .map((val) => getValueByPath(item, val))
            .filter((v) => v !== null && v !== undefined)
            .join(" | ")
        : item?.[traditional_chinese] || item?.name_traditional_chinese || "",
      value: item?.[value] || item?.id,
    }));
  };
  const getLocale = (lang) => {
    if (lang === "SC") {
      dayjs.locale("zh-cn");
      return zhCN;
    }
    if (lang === "TC") {
      dayjs.locale("zh-tw");
      return zhTW;
    }

    dayjs.locale("en");
    return enUS;
  };

  const getDateFormatByLang = (lang) => {
  switch (lang) {
    case "EN":
      return "DD MMM YYYY";
    case "SC":
      return "YYYY年MM月DD日";
    case "TC":
      return "YYYY年MM月DD日";
    default:
      return "DD MMM YYYY";
  }
};

  const parseLangDate = (value) => {
    if (!value) return null;
    if (Array.isArray(value)) {
      return value.map(v => toSingaporeDate(v));
    }

    if (/^\d{4}-\d{2}-\d{2}/.test(value)) {
      return [toSingaporeDate(value)];
    }

    if (value.includes("年") && (value.includes("-") || value.includes("至"))) {
      const clean = value.replace(/\s*/g, "");
      const [start, end] = clean
        .replace(/日/g, "")
        .split(/-|至/)
        .map(s => s.replace(/[年月]/g, "-"));

      return [toSingaporeDate(start), toSingaporeDate(end)];
    }

    if (value.includes("年") && value.includes("日")) {
      const clean = value.replace(/[年月]/g, "-").replace("日", "");
      return [toSingaporeDate(clean)];
    }

    if (value.includes("-")) {
      const [start, end] = value.split("-").map(x => x.trim());
      return [toSingaporeDate(start), toSingaporeDate(end)];
    }
    return [toSingaporeDate(value)];
  };

  const [urlErrors, setUrlErrors] = useState({});

  const isValidUrl = (value) => {
    try {
      new URL(value);
      return true;
    } catch {
      return false;
    }
  };
  // const  getMenu= async () => {
  //   const data = {};

  //   for (const item of attributes) {
  //     if (item.type === "asyncselect") {
  //       data[item.key] = await getData(
  //         item.slug,
  //         item.label,
  //         item.value,
  //         item.type,
  //         item.query,
  //         item.simplified_chinese,
  //         item.traditional_chinese
  //       );
  //     }
  //   }

  //   setMenuValues(data);
  // };

  return (
    <div className="row" style={{ width: "100%", marginLeft: "2px" }}>
      {attributes?.map((item, index) => {
        if (item.type === "date") {
          const todayStr = dayjs().format("YYYY-MM-DD");
          let minDate = todayStr;
          if (item.key === "end_date") {
            const startDateValue = data["start_date"];
            if (startDateValue && dayjs(startDateValue).isAfter(dayjs(todayStr))) {
              minDate = dayjs(startDateValue).format("YYYY-MM-DD");
            }
          }
          const isEndBeforeStart =
            item.key === "end_date" &&
            data["start_date"] &&
            data[item.key] &&
            dayjs(data[item.key]).isBefore(dayjs(data["start_date"]));

          return (
            <div key={index + ""} className={` ${item.className}`}>
              <div className="fieldrow">
                <label className="f_label">
                  {" "}
                  {item.title}{" "}
                  {item?.required && <span style={{ color: "red" }}>*</span>}
                </label>
                <input
                  required
                  value={data[item.key]}
                  min={minDate}
                  onChange={(e) => {
                    setData({
                      ...data,
                      [item.key]: e.target.value,
                    });
                  }}
                  className="f_input"
                  type="date"
                />
                {(error?.includes(item.key) || isEndBeforeStart) && (
                  <span
                    style={{
                      color: "red",
                      marginTop: "5px",
                      fontWeight: "bold",
                      fontSize: 13,
                    }}
                  >
                    {isEndBeforeStart
                      ? "End Date cannot be earlier than Start Date"
                      : `${item.title} is required`}
                  </span>
                )}
              </div>
            </div>
          );
        }
        if (item.type === "date-lang") {
          return (
            <div key={index + ""} className={`${item.className}`}>
              <div className="fieldrow">
                <label className="f_label">
                  {item.title}
                  {item?.required && <span style={{ color: "red" }}>*</span>}
                </label>

                <RangePicker
                  key={`${item.key}-${!!data[item.key]}`}
                  locale={getLocale(item.lang)}
                 value={parseLangDate(data[item.key])}
                  onChange={(val) => {
                    if (!!val) {
                      setData({
                        ...data,
                        [item.key]: val.map((d) =>
                          toSingaporeDate(d).format("YYYY-MM-DD")
                        ),
                      });
                    } else {
                      setData({
                        ...data,
                        [item.key]: null,
                      });
                    }
                  }}
                  format={getDateFormatByLang(item.lang)}
                  className="f_input"
                  style={{ width: "100%", display: "flex", fontSize: "16px" }}
                />

                {error?.includes(item.key) && (
                  <span
                    style={{
                      color: "red",
                      marginTop: "5px",
                      fontWeight: "bold",
                      fontSize: 13,
                    }}
                  >
                    {item.title} is required
                  </span>
                )}
              </div>
            </div>
          );
        }

        if (item?.type === "input") {
          return (
            <div key={index + ""} className={` ${item.className}`}>
              <div className="fieldrow">
                <label className="f_label">
                  {item.title}{" "}
                  {item?.required && <span style={{ color: "red" }}>*</span>}
                </label>
                <input
                  className="f_input"
                  // required
                  type={item?.inputType || "text"}
                  placeholder={item?.placeholder || ""}
                  value={data[item.key]}
                  onChange={(e) => {
                    const val = e.target.value
                    setData({
                      ...data,
                      [item.key]: e.target.value,
                    });
                    if (item?.inputType === "url" || item?.key?.toLowerCase().includes("url")) {
                      if (val && !isValidUrl(val)) {
                        setUrlErrors((prev) => ({ ...prev, [item.key]: "Please enter a valid URL (e.g. https://example.com)" }));
                      } else {
                        setUrlErrors((prev) => ({ ...prev, [item.key]: null }));
                      }
                    }
                  }}
                />
                {(error?.includes(item.key) || urlErrors[item.key]) && (
                  <span style={{ color: "red", marginTop: "5px", fontWeight: "bold", fontSize: 13 }}>
                    {urlErrors[item.key]
                      ? urlErrors[item.key]
                      : (item?.inputType === "url" || item?.key?.toLowerCase().includes("url")) && data?.[item.key] && isValidUrl(data?.[item.key])
                        ? null
                        : (item?.inputType === "url" || item?.key?.toLowerCase().includes("url")) && data?.[item.key]
                          ? "Please enter a valid URL (e.g. https://example.com)"
                          : `${item.title} is required`}
                  </span>
                )}
              </div>
            </div>
          );
        } else if (item?.type === "textarea") {
          return (
            <div key={index + ""} className={` ${item.className}`}>
              <div className="fieldrow">
                <label className="f_label">
                  {item.title}{" "}
                  {item?.required && <span style={{ color: "red" }}>*</span>}
                </label>
                <textarea
                  className="f_input"
                  rows={item?.rows || 4} // optional rows
                  placeholder={item?.placeholder || ""}
                  value={data[item.key] || ""}
                  onChange={(e) => {
                    setData({
                      ...data,
                      [item.key]: e.target.value,
                    });
                  }}
                />
                {error?.includes(item.key) && (
                  <span
                    style={{
                      color: "red",
                      marginTop: "5px",
                      fontWeight: "bold",
                      fontSize: 13,
                    }}
                  >
                    {item.title} is required
                  </span>
                )}
              </div>
            </div>
          );
        } else if (item?.type === "html") {
          return (
            <div key={index + ""} className={` ${item.className}`}>
              <div className="fieldrow">
                <label className="f_label">
                  {item.title}
                  {item?.required && <span style={{ color: "red" }}>*</span>}
                </label>
                <div style={{ height: "300px", marginBottom: "3.1rem" }}>
                  {level === 1 ? (
                    <ReactQuillData2
                      level={level}
                      key={index + ""}
                      theme="snow"
                      style={{ height: "200px" }}
                      data={data[item.key]}
                      setData={(e) => {
                        setData({
                          ...data,
                          [item.key]: e,
                        });
                      }}
                    />
                  ) : (
                    // <div></div>
                    <ReactQuillData
                      level={level}
                      active={active}
                      key={index + ""}
                      theme="snow"
                      style={{ height: "200px" }}
                      data={data[item.key]}
                      setData={(e) => {
                        setData({
                          ...data,
                          [item.key]: e,
                        });
                      }}
                    />
                  )}
                </div>{" "}
                {error?.includes(item.key) && (
                  <span
                    style={{
                      color: "red",
                      fontWeight: "bold",
                      fontSize: "14px",
                    }}
                  >
                    {item.title} is required
                  </span>
                )}
              </div>
            </div>
          );
        } else if (item?.type === "editor") {
          return (
            <div key={index + ""} className={` ${item.className}`}>
              <div className="fieldrow">
                <label className="f_label">
                  {item.title}{" "}
                  {item?.required && <span style={{ color: "red" }}>*</span>}
                </label>
                <div
                  style={{
                    minHeight: item.height || "300px",
                    width: "100%",
                  }}
                >
                  <RichEditor
                    level={level}
                    key={index + ""}
                    theme="snow"
                    style={{ height: "200px" }}
                    data={data[item.key]}
                    setData={(e) => {
                      setData({
                        ...data,
                        [item.key]: e,
                      });
                    }}
                  />
                </div>{" "}
                {error?.includes(item.key) && (
                  <span
                    style={{
                      color: "red",
                      fontWeight: "bold",
                      fontSize: "14px",
                    }}
                  >
                    {item.title} is required
                  </span>
                )}
              </div>
            </div>
          );
        } else if (item?.type === "asyncselect") {
          if (menuValues?.[item.key])
            return (
              <div key={index} className={`${item.className} row`}>
                <div
                  className={
                    !item?.simplified_chinese ? "fieldrow" : "fieldrow col-lg-3"
                  }
                >
                  <label className="f_label">
                    {extralabel || ""} {item.title}{" "}
                    {item?.required && <span style={{ color: "red" }}>*</span>}
                  </label>

                  <Autocomplete
                    options={menuValues[item.key] || []}
                    value={
                      menuValues[item.key]?.find(
                        (opt) => opt.value === data[item.key]
                      ) || null
                    }
                    onChange={(e, newValue) => {
                      if (!newValue) {
                        setData({
                          ...data,
                          [item.key]: "",
                          english: "",
                          simplified_chinese: "",
                          traditional_chinese: "",
                        });
                        return;
                      }

                      // console.log("Selected venue:", newValue);
                      const englishStr = newValue.data
                        ? newValue.data
                            .map((d) => {
                              const deckLabel =
                                keyworkTranslation[d.location]?.english ||
                                d.location;
                              const sideLabel = d.side || "";
                              return d.deck_number
                                ? `Deck ${d.deck_number}${
                                    deckLabel ? `, ${deckLabel}` : ""
                                  }${sideLabel ? `, ${sideLabel}` : ""}`
                                : "NA";
                            })
                            .join(" | ")
                        : newValue?.label || newValue?.name || "";

                      const simplifiedStr = newValue.data
                        ? newValue.data
                            .map((d) => {
                              const deckLabel =
                                keyworkTranslation.Deck.simplified_chinese;
                              const locationLabel =
                                keyworkTranslation[d.location]
                                  ?.simplified_chinese || d.location;
                              const sideLabel =
                                keyworkTranslation[d.side]
                                  ?.simplified_chinese ||
                                d.side_simplified_chinese ||
                                "";
                              return d.deck_number
                                ? `${deckLabel} ${d.deck_number}${
                                    locationLabel ? `, ${locationLabel}` : ""
                                  }${sideLabel ? `, ${sideLabel}` : ""}`
                                : "NA";
                            })
                            .join(" | ")
                        : newValue?.simplified_chinese ||
                          newValue?.name_simplified_chinese ||
                          "";

                      const traditionalStr = newValue.data
                        ? newValue.data
                            .map((d) => {
                              const deckLabel =
                                keyworkTranslation.Deck.traditional_chinese;
                              const locationLabel =
                                keyworkTranslation[d.location]
                                  ?.traditional_chinese || d.location;
                              const sideLabel =
                                keyworkTranslation[d.side]
                                  ?.traditional_chinese ||
                                d.side_traditional_chinese ||
                                "";
                              return d.deck_number
                                ? `${deckLabel} ${d.deck_number}${
                                    locationLabel ? `, ${locationLabel}` : ""
                                  }${sideLabel ? `, ${sideLabel}` : ""}`
                                : "NA";
                            })
                            .join(" | ")
                        : newValue?.traditional_chinese ||
                          newValue?.name_traditional_chinese ||
                          "";

                      setData({
                        ...data,
                        [item.key]: parseInt(newValue.value),
                        english: englishStr,
                        simplified_chinese: simplifiedStr,
                        traditional_chinese: traditionalStr,
                      });
                    }}
                    isOptionEqualToValue={(option, value) =>
                      option.value === value.value
                    }
                    sx={{ width: "100%" }}
                    getOptionLabel={(option) => {
                      if (!option) return "NA";
                      const isDeck = item?.title === "Deck";

                      const details = option?.data
                        ?.map((d) => {
                          const hasDeck = !!d.deck_number;
                          const location = d.location || "";
                          const side = d.side || "";

                          return hasDeck
                            ? `Deck ${d.deck_number}${
                                location ? " – " + location : ""
                              }${side ? ", " + side : ""}`
                            : "NA";
                        })
                        .join(", ");
                      return `${isDeck ? "" : option?.name || ""}${
                        details &&
                        (!isDeck && option?.name ? " | " + details : details)
                      }`;
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder={`Search ${item.title}`}
                        size="small"
                        sx={{ width: "100%" }}
                      />
                    )}
                    renderOption={(props, option) => {
                      const isDeck = item?.title === "Deck";

                      const validDecks =
                        option?.data?.filter((d) => d.deck_number) || [];

                      // ⛔ Skip rendering if it's a Deck and there are no deck numbers
                      if (isDeck && validDecks.length === 0) return null;

                      const deckHtml =
                        validDecks.length > 0
                          ? validDecks
                              .map(
                                (d) =>
                                  `<span style="color:#555;">Deck ${
                                    d.deck_number
                                  }</span>${
                                    d.location ? ` – ${d.location}` : ""
                                  }${
                                    d.side
                                      ? ` <em style="color:#999;">(${d.side})</em>`
                                      : ""
                                  }`
                              )
                              .join("<br/>")
                          : "<i style='color:#888;'>NA</i>";

                      return (
                        <li {...props}>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: `
            ${
              !isDeck
                ? `<strong style="font-size:14px;">${option?.name}</strong><br/>`
                : ""
            }
            ${deckHtml}
          `,
                            }}
                          />
                        </li>
                      );
                    }}
                  />

                  {error?.includes(item.key) && (
                    <span
                      style={{
                        color: "red",
                        marginTop: "5px",
                        fontWeight: "bold",
                        fontSize: 13,
                      }}
                    >
                      {extralabel || ""} {item.title} is required
                    </span>
                  )}
                </div>
                {item.simplified_chinese && (
                  <div className="fieldrow col-lg-3">
                    <label className="f_label">English {item.title} </label>
                    <input
                      className="f_input"
                      // required
                      type="text"
                      disabled
                      value={data?.english}
                      onChange={(e) => {
                        setData({
                          ...data,
                          [item.key]: e.target.value,
                        });
                      }}
                    />
                  </div>
                )}
                {item.simplified_chinese && (
                  <div className="fieldrow col-lg-3">
                    <label className="f_label">
                      Simplified Chinese {item.title}{" "}
                    </label>
                    <input
                      className="f_input"
                      // required
                      type="text"
                      disabled
                      value={data?.simplified_chinese}
                      onChange={(e) => {}}
                    />
                  </div>
                )}
                {item.traditional_chinese && (
                  <div className="fieldrow col-lg-3">
                    <label className="f_label">
                      Traditional Chinese {item.title}{" "}
                    </label>
                    <input
                      className="f_input"
                      // required
                      type="text"
                      disabled
                      value={data?.traditional_chinese}
                      onChange={(e) => {}}
                    />
                  </div>
                )}
              </div>
            );
        } else if (item?.type === "select") {
          return (
            <div key={index + ""} className={` ${item.className}`}>
              <div className="fieldrow">
                <label className="f_label">
                  {item.title}{" "}
                  {item?.required && <span style={{ color: "red" }}>*</span>}
                </label>
                <Select
                  required
                  style={{ width: "100%", height: "45px" }}
                  value={data[item.key]}
                  onChange={(e) => {
                    setData({
                      ...data,
                      [item.key]: e.target.value,
                    });
                  }}
                >
                  {getMenu(item)}
                </Select>
                {error?.includes(item.key) && (
                  <span
                    style={{
                      color: "red",
                      marginTop: "5px",
                      fontWeight: "bold",
                      fontSize: 13,
                    }}
                  >
                    {item.title} is required
                  </span>
                )}
              </div>
            </div>
          );
        } else if (item?.type === "ship") {
          return (
            <>
              {!item?.multiple ? (
                <div key={index + ""} className={` ${item.className}`}>
                  <div className="fieldrow">
                    <label className="f_label">
                      {item.title}{" "}
                      {item?.required && (
                        <span style={{ color: "red" }}>*</span>
                      )}
                    </label>
                    <Select
                      required
                      style={{ width: "100%", height: "45px" }}
                      value={data[item.key] || ""}
                      onChange={(e) => {
                        setData({
                          ...data,
                          [item.key]: e.target.value,
                        });
                      }}
                    >
                      <MenuItem key={"all"} value={""}>
                        All
                      </MenuItem>
                      {getMenu({ ...item, option: ships })}
                    </Select>
                    {error?.includes(item.key) && (
                      <span
                        style={{
                          color: "red",
                          marginTop: "5px",
                          fontWeight: "bold",
                          fontSize: 13,
                        }}
                      >
                        {item.title} is required
                      </span>
                    )}
                  </div>
                </div>
              ) : (
                <div key={index + ""} className={` ${item.className}`}>
                  <div className="fieldrow">
                    <label className="f_label">
                      {item.title}{" "}
                      {item?.required && (
                        <span style={{ color: "red" }}>*</span>
                      )}
                    </label>
                    <Select
                      multiple
                      required
                      style={{ width: "100%", height: "45px" }}
                      value={mutliSelectShip}
                      onChange={(e) => {
                        const val = e.target.value;
                        setMutliSelectShip(val);
                        setData({
                          ...data,
                          [item.key]: val,
                        });
                      }}
                      renderValue={(selectedValues) => {
                        const selected = Array.isArray(selectedValues)
                          ? selectedValues
                          : [selectedValues];
                        return (
                          <Box
                            sx={{
                              display: "flex",
                              gap: 0.5,
                              overflow: "scroll",
                            }}
                            className="noScrollBar"
                          >
                            {selected.map((value, index) => (
                              <Chip
                                key={value}
                                onMouseDown={(event) => {
                                  event.stopPropagation();
                                }}
                                color="error"
                                onDelete={() => {
                                  const updated = mutliSelectShip.filter(
                                    (val) => val !== value
                                  );
                                  setMutliSelectShip(updated);
                                  setData({
                                    ...data,
                                    [item.key]: updated,
                                  });
                                }}
                                sx={{
                                  borderRadius: "4px",
                                  "& .MuiChip-label": {
                                    color: "white",
                                    fontWeight: "bold",
                                  },
                                }}
                                label={
                                  ships.find((ship) => ship.id == value)?.name
                                }
                              ></Chip>
                            ))}
                          </Box>
                        );
                      }}
                    >
                      {/* <MenuItem key={"all"} value={""}>
                     All
                  </MenuItem> */}
                      {ships.map((sh, i) => (
                        <MenuItem key={i + ""} value={sh?.id}>
                          {sh.name}
                        </MenuItem>
                      ))}
                    </Select>
                    {error?.includes(item.key) && (
                      <span
                        style={{
                          color: "red",
                          marginTop: "5px",
                          fontWeight: "bold",
                          fontSize: 13,
                        }}
                      >
                        {item.title} is required
                      </span>
                    )}
                  </div>
                </div>
              )}
            </>
          );
        } else if (item?.type === "country") {
          return (
            <div key={index + ""} className={` ${item.className}`}>
              <div className="fieldrow">
                <CountryLocation
                  itemType={item}
                  displayLocation={countryLocation}
                  locationOption={locationOption}
                  nondisplay
                  setDisplayLocation={(ids) => {
                    // Convert IDs back to names before saving
                    const names = ids.map(
                      (id) =>
                        locationOption.find((loc) => loc.id === id)
                          ?.location_name
                    );
                    setData((itemData) => ({
                      ...itemData,
                      country: names,
                    }));
                  }}
                />
                {error?.includes(item.key) && (
                  <span
                    style={{
                      color: "red",
                      marginTop: "5px",
                      fontWeight: "bold",
                      fontSize: 13,
                    }}
                  >
                    {item.title} is required
                  </span>
                )}
              </div>
            </div>
          );
        } else if (item?.type === "file") {
          return (
            <div key={index + ""} className={item.className}>
              <UploadFileForm
                required={item.required}
                type={item?.filetype || "image"}
                key={index + ""}
                label={item.title}
                placeholder={item.placeholder}
                image={data[item.key]}
                maxSize={item.maxSize}
                setImage={(e) => {
                  setData({
                    ...data,
                    [item.key]: e,
                  });
                }}
              />
              {error?.includes(item.key) && (
                <span
                  style={{
                    color: "red",
                    marginTop: "5px",
                    fontWeight: "bold",
                    fontSize: 13,
                  }}
                >
                  {item.title} is required
                </span>
              )}
              {item?.withAlt && (
                <div className="fieldrow">
                  <label className="f_label">{item.title} Alt Text</label>
                  <input
                    className="f_input"
                    type="text"
                    maxLength={255}
                    placeholder=""
                    value={data[`${item.key}_alt`] || ""}
                    onChange={(e) => {
                      setData({
                        ...data,
                        [`${item.key}_alt`]: e.target.value,
                      });
                    }}
                  />
                </div>
              )}
            </div>
          );
        } // else if (item?.type === "asyncselect") {
        //   if (menuValues?.[item.key])
        //     return (
        //       <div key={index} className={` ${item.className}`}>
        //         <div className="fieldrow">
        //           <label className="f_label">
        //             {extralabel || ""} {item.title}{" "}
        //             {item?.required && <span style={{ color: "red" }}>*</span>}
        //           </label>
        //           <Select
        //             required
        //             style={{ width: "100%", height: "45px" }}
        //             value={data[item.key] ? data[item.key] + "" : ""}
        //             onChange={(e) => {
        //               setData({
        //                 ...data,
        //                 [item.key]: parseInt(e.target.value),
        //               });
        //             }}
        //           >
        //             {menuValues?.[item.key]?.map((item, index) => (
        //               <MenuItem key={index} value={item?.value + ""}>
        //                 {item.label}
        //               </MenuItem>
        //             ))}
        //           </Select>
        //           {error?.includes(item.key) && (
        //             <span
        //               style={{
        //                 color: "red",
        //                 marginTop: "5px",
        //                 fontWeight: "bold",
        //                 fontSize: 13,
        //               }}
        //             >
        //               {extralabel || ""} {item.title} is required
        //             </span>
        //           )}
        //         </div>
        //       </div>
        //     );
        // }
      })}
    </div>
  );
};
DyanmicFrom.propTypes = {
  attributes: PropTypes.any,
  data: PropTypes.any,
  rootData: PropTypes.any,
  setData: PropTypes.any,
  level: PropTypes.any,
  active: PropTypes.any,
  error: PropTypes.any,
};

export default DyanmicFrom;
